import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "base-data-table" }
const _hoisted_2 = { class: "sticky-table-wrapper" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "td-content"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  class: "td-content"
}
const _hoisted_8 = {
  key: 1,
  class: "d-flex align--center justify--end table-pagination"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, " Page ", -1)

import { ref, watch }  from 'vue';
import {
  MAX_RECORDS,
} from '@/utils/constants/index';
import {
  TableField,
} from '@/utils/types/index';
import { useFormatter } from '@/composables/useFormatter';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseDataTable',
  props: {
    tableName: { default: 'table' },
    page: { default: 1 },
    maxRecords: { default: MAX_RECORDS },
    tableFields: { default: () => ([]) },
    firstColumnSticky: { type: Boolean, default: false },
    lastColumnSticky: { type: Boolean, default: false },
    headerSticky: { type: Boolean, default: false },
    hasPagination: { type: Boolean, default: false },
    dataTable: { default: () => ([]) },
    rowActiveCondition: { default: () => (() => { return false; }) }
  },
  emits: [
  'on-update-page',
  'on-row-click',
],
  setup(__props: any, { emit }) {

const props = __props as { tableName: string, page: number, maxRecords: number, tableFields: TableField[], firstColumnSticky: boolean, lastColumnSticky: boolean, headerSticky: boolean, hasPagination: boolean, dataTable: any[], rowActiveCondition: any }





watch(() => props.page, (newValue) => {
  pageNumber.value = newValue;
});

const { numberFormatter } = useFormatter();

const pageNumberForm = ref<any>(null);
const pageNumber = ref(1);

function previousPage () {
  if (pageNumber.value > 1) {
    pageNumber.value--;
    emit('on-update-page', pageNumber.value);
  }
}
function nextPage () {
  pageNumber.value++;
  emit('on-update-page', pageNumber.value);
}
function updatePage () {
  if (pageNumber.value < 1) {
    pageNumber.value = 1;
  }
  emit('on-update-page', pageNumber.value);
}
function onRowClick (item: any) {
  emit('on-row-click', item);
}

return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_form = _resolveComponent("va-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", {
        class: _normalizeClass([
          'table',
          __props.firstColumnSticky ? 'sticky-first-column' : null,
          __props.lastColumnSticky ? 'sticky-last-column' : null,
          __props.headerSticky ? 'sticky-header' : null,
        ])
      }, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableFields, (field, index) => {
              return (_openBlock(), _createElementBlock("th", {
                key: `header-${field.key}-${index}`,
                class: _normalizeClass([
                field.class ? field.class : null,
                field.primaryHighlight ? 'primary-bg' : null,
                field.secondaryHighlight ? 'secondary-bg' : null,
              ]),
                style: _normalizeStyle({
                width: field.width || 'auto',
              })
              }, _toDisplayString(field.label), 7))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataTable, (item, rowIndex) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: `row-${__props.tableName}-${rowIndex}`,
              class: _normalizeClass([
              __props.rowActiveCondition(item, rowIndex) ? 'row-active' : null,
            ]),
              onClick: ($event: any) => (onRowClick(item, rowIndex))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableFields, (field, columnIndex) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: `td-${__props.tableName}-${field.key}`,
                  class: _normalizeClass([
                field.primaryHighlight ? 'primary-bg' : null,
                field.secondaryHighlight ? 'secondary-bg' : null,
              ])
                }, [
                  (_ctx.$slots[`td(${field.key})`])
                    ? _renderSlot(_ctx.$slots, `td(${field.key})`, {
                        key: 0,
                        item: item,
                        index: columnIndex
                      })
                    : (field.numberFormat)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          (!item[field.key] && !field.decimal)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " - "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(numberFormatter)(item[field.key], { decimal: field.decimal })) + _toDisplayString(field.showPercent ? '%' : ''), 1))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("span", null, _toDisplayString(item[field.key] ? item[field.key] : '-'), 1)
                        ]))
                ], 2))
              }), 128))
            ], 10, _hoisted_3))
          }), 128))
        ])
      ], 2)
    ]),
    (_ctx.$slots['table-bottom'])
      ? _renderSlot(_ctx.$slots, "table-bottom", { key: 0 })
      : _createCommentVNode("", true),
    (__props.hasPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_va_button, {
            class: "left-btn",
            disabled: (pageNumber.value === 1),
            preset: "plain",
            icon: "chevron_left",
            onClick: previousPage
          }, null, 8, ["disabled"]),
          _createVNode(_component_va_form, {
            ref_key: "pageNumberForm",
            ref: pageNumberForm,
            tag: "form",
            class: "flex flex-col gap-6",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (updatePage()), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_va_input, {
                modelValue: pageNumber.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageNumber).value = $event)),
                class: "mb-6 page-number-input"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_va_button, {
            class: "right-btn",
            disabled: (__props.dataTable.length < __props.maxRecords),
            preset: "plain",
            icon: "chevron_right",
            onClick: nextPage
          }, null, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})